var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['puntata-button', {'selected' : _vm.isSelected}],on:{"click":_vm.clickBtn}},[_c('span',{domProps:{"textContent":_vm._s(_vm.number)}})])}
var staticRenderFns = []

export { render, staticRenderFns }